import React, { useState } from 'react';
import { ChevronDown, Building2 } from 'lucide-react';

const ClientSelector = ({
  customerData,
  allClients,
  onClientChange,
  showClientSelector,
  textColor,
  isIBRole
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const getInitials = (name) => {
    if (!name) return '';
    return name
      .split(' ')
      .map(part => part[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  const handleClientSelect = (client) => {
    onClientChange(client);
    setDropdownOpen(false);
  };

  return (
    <div className="flex items-center gap-4">
      {customerData?.img ? (
        <img
          src={customerData.img}
          className={`w-20 h-20 object-cover flex-shrink-0 hover:scale-104 transition-transform duration-200 ${isIBRole ? 'rounded-lg' : 'rounded-full'}`}
          alt={customerData?.name || "Client"}
        />
      ) : isIBRole ? (
        <div className="w-20 h-20 rounded-lg bg-gray-100 border border-gray-200 flex items-center justify-center flex-shrink-0 hover:scale-104 transition-transform duration-200">
          {customerData?.name
            ? <span className="text-xl font-semibold text-primaryLight">{getInitials(customerData.name)}</span>
            : <Building2 className="w-8 h-8 text-gray-400" />}
        </div>
      ) : (
        <div className="w-20 h-20 rounded-full bg-gray-200 flex items-center justify-center text-xl font-semibold text-primaryLight flex-shrink-0 hover:scale-104 transition-transform duration-200">
          {getInitials(customerData?.name)}
        </div>
      )}
      <div className="flex flex-col">
        <div className="relative inline-block">
          <h1
            className={`text-2xl font-bold text-primary mb-1 flex items-center gap-1.5 ${showClientSelector && allClients && allClients.length > 0 ? 'cursor-pointer select-none' : ''}`}
            onClick={() => showClientSelector && allClients && allClients.length > 0 && setDropdownOpen(!dropdownOpen)}
            style={{ color: textColor || 'inherit' }}
          >
            {customerData?.name || "No clients available"}
            {showClientSelector && allClients && allClients.length > 0 && (
              <ChevronDown size={20} className={`transition-transform duration-200 ${dropdownOpen ? 'rotate-180' : ''}`} />
            )}
          </h1>

          {dropdownOpen && showClientSelector && allClients && allClients.length > 0 && (
            <div className="absolute top-full left-0 z-[1000] min-w-[180px] max-h-[250px] overflow-y-auto bg-white rounded-md shadow-lg border border-gray-200 py-1.5 mt-0.5 animate-[fadeIn_0.2s_ease]">
              {allClients.map(client => (
                <div
                  key={client.id}
                  className="py-1.5 px-3 cursor-pointer transition-colors duration-200 text-sm whitespace-nowrap overflow-hidden text-ellipsis hover:bg-gray-100"
                  onClick={() => handleClientSelect(client)}
                >
                  {client.name}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ClientSelector;